import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { authKeys } from '@field-tickets/shared';
import { useIntentionalSignOut } from '@/hooks/useIntentionalSignOut';

const POLL_INTERVAL_MS = 10_000;

export function PendingApprovalPage() {
  const queryClient = useQueryClient();
  const signOut = useIntentionalSignOut();

  // Poll /auth/me every 10 s so the page auto-redirects once the invitation is
  // accepted and the membership turns active — no manual refresh required.
  useEffect(() => {
    const id = setInterval(() => {
      queryClient.invalidateQueries({ queryKey: authKeys.me });
    }, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [queryClient]);

  return (
    <div className="login-page">
      {signOut.dialog}
      <svg
        aria-hidden="true"
        style={{ width: 48, height: 48, color: 'var(--color-warning)', marginBottom: 'var(--space-4)' }}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>

      <h1 className="login-title">Invitation pending</h1>
      <p className="login-subtitle" style={{ maxWidth: 340 }}>
        Your invitation has not been accepted yet. Open the invitation email and accept it, or ask an Admin, Manager or Sales person to resend it.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', width: '100%', maxWidth: 320, marginTop: 'var(--space-4)' }}>
        <button
          type="button"
          className="login-btn"
          onClick={() => { void signOut.requestSignOut(); }}
          disabled={signOut.isPending}
          style={{ textAlign: 'center' }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
